
import { Suspense } from 'react';

const LazyWrapper = ({ component: Component }) => (
  <Suspense fallback={<div>Loading...</div>}>
    <Component />
  </Suspense>
);

export default LazyWrapper;